import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import Flex from '../common/Flex';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { toast } from 'react-toastify';
import { UploadFile } from 'api/endpoints';
import DropzoneFilePreviewer from 'components/ckeditor/DropZoneFilePrevier';
import IconButton from 'components/common/IconButton';


const MEIDropzone = ({
  placeholder,
  className,
  onChange,
  files,
  preview,
  setLoading,
  ...rest
}) => {


  const [tUrls, setTurls] = useState([]);
  useEffect(() => {
    const parsedString = files.replace(/\\"/g, '"');
    const pFiles = parsedString ? JSON.parse(parsedString) : [];
    setTurls(pFiles);
  }, [files])

  const onDrop = async (acceptedFiles) => {
    const allowedTypes = [
      'image/jpeg',
      'image/png',
      'video/mp4'
    ];

    const validFiles = acceptedFiles.filter(file => allowedTypes.includes(file.type));

    if (validFiles.length !== acceptedFiles.length) {
      toast.error('Invalid File Format Selected, Image and Video (.mp4) allowed', { theme: "colored" });
      return;
    }

    if (validFiles.length > 0) {
      setLoading(true);
      try {
        const uploadPromises = validFiles.map(file => {
          const formData = new FormData();
          formData.append('file', file);
          return UploadFile(formData).then(res => {
            if (res?.data) {
              return res.data;
            }
          });
        });
        const uploadedUrls = await Promise.all(uploadPromises);
        const successfulUrls = uploadedUrls.filter(url => url);
        onChange([...tUrls, ...successfulUrls]);
        setLoading(false);
      } catch (err) {
        console.log(err)
        setLoading(false);
        toast.error('File Uploading Failed', { theme: "colored" });
      }
    }


  };


  return (
    <>
      <Dropzone
        onDrop={onDrop}
      >
        {({ getRootProps, getInputProps }) => (
          <div
            {...getRootProps({
              className: classNames('dropzone-area', className)
            })}
          >
            <input {...{ ...getInputProps(), ...rest }} />
            {placeholder}



            <div className="border-top mt-3 d-flex gap-3">
              {tUrls.map((file, index) => (
                <Flex
                  alignItems="center"
                  className="py-3 border-bottom btn-reveal-trigger"
                  key={index}
                  style={{ position: 'relative' }}
                >

                  <DropzoneFilePreviewer furl={file || ''} />
                  <IconButton icon='times' variant='danger' size='sm' style={{ position: 'absolute', right: 0, top: 10 }} onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();



                    const updatedUrls = [...tUrls];
                    updatedUrls.splice(index, 1)
                    console.log(updatedUrls)
                    setTurls(updatedUrls)
                    onChange(updatedUrls);

                  }}>
                  </IconButton>
                </Flex>
              ))}
            </div>

          </div>
        )}
      </Dropzone>
    </>
  )

};

MEIDropzone.propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  files: PropTypes.string,
  preview: PropTypes.bool,
  isMulti: PropTypes.bool
};

MEIDropzone.defaultProps = {
  placeholder: <img src={cloudUpload} alt="" width={25} className="me-2" />,
  files: '',
  preview: true
};

export default MEIDropzone;
